




























































import Vue from "vue"
import {mapState} from "vuex"
// eslint-disable-next-line no-unused-vars
import {DowntimeAction, DowntimeActionType} from "@/types/downtime";
// eslint-disable-next-line no-unused-vars
import {Upgrade} from "@/types/upgrade";
import {getHealAmount} from "@/lib/players";

type DowntimeData = {
	selections: Record<number, DowntimeAction>
}
	export default Vue.extend({
		name: 'Downtime',
		computed: {
			...mapState(['players'])
		},
		data () : DowntimeData {
			return {
				selections: {}
			}
		},
		methods: {
      getHealAmount: getHealAmount,
			confirmDowntime () {
				this.$store.dispatch('doDowntime', this.selections)
			},
			toggleSelection (playerIndex: number, actionType : DowntimeActionType, upgradeName = "") {
				const action : DowntimeAction = {
					type: actionType
				}

				const upgrade = this.players[playerIndex].upgrades.find((u : Upgrade) => u.name === upgradeName)
				if (upgrade && upgrade.level >= upgrade.maxLevel) {
					return
				}

				if (actionType == 'upgrade') {
					action.upgradeName = upgradeName
				}
				Vue.set(this.selections, playerIndex, action)
			}
		}
	})
